import React from "react";

export default function Button({ children, handleOpen }) {
  return (
    <button
      className="rounded-[10px] bg-[#0075FF] px-[23px] py-[12px] text-center font-outfit text-[16px] font-medium leading-[20.16px] text-white"
      onClick={handleOpen}
    >
      {children}
    </button>
  );
}
